import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

import { API_ENDPOINT } from "../../config";
import {
  ListResponse,
  CreateArticleDto,
  GetArticleDto,
  Article,
  UpdateArticleDto,
  ArticleStatus,
} from "../../interfaces";
import { toastMessage } from "../../utils/toastError";

export const articleApi = createApi({
  reducerPath: "articleApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/article",
    credentials: "include",
  }),
  tagTypes: ["Articles"],
  endpoints: (build) => ({
    getArticle: build.query<Article, string>({
      query: (id) => ({
        url: "/" + id,
        method: "GET",
      }),
    }),
    getArticles: build.query<ListResponse<Article>, GetArticleDto>({
      query: (params) => ({
        url: "/",
        method: "GET",
        params,
      }),
      providesTags: ["Articles"],
    }),
    getArticleStats: build.query<{ articles: number; subjects: number; chapters: number }, void>({
      query: () => ({
        url: "/stats",
        method: "GET",
      }),
    }),
    createArticle: build.mutation<Article, CreateArticleDto>({
      query: (payload) => ({
        url: "/",
        method: "POST",
        body: payload,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue: Article) {
        toastMessage("success", "Successfully created");
        return baseQueryReturnValue;
      },
      invalidatesTags: ["Articles"],
    }),
    updateArticle: build.mutation<Article, UpdateArticleDto>({
      query: (payload) => ({
        url: "/",
        method: "PUT",
        body: payload,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        console.log(baseQueryReturnValue.data);
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue: Article) {
        toastMessage("success", "Successfully updated");
        return baseQueryReturnValue;
      },
      invalidatesTags: ["Articles"],
    }),

    deleteArticle: build.mutation<any, string[]>({
      query: (ids) => ({
        url: "/",
        method: "DELETE",
        body: { ids },
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue) {
        toastMessage("success", "Successfully deleted");
        return baseQueryReturnValue;
      },
      invalidatesTags: ["Articles"],
    }),
    statusUpdateArticle: build.mutation<any, { ids: string[]; status: ArticleStatus }>({
      query: (payload) => ({
        url: "/trash",
        method: "PUT",
        body: payload,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue) {
        toastMessage("success", "Successfully moved to trash");
        return baseQueryReturnValue;
      },
      invalidatesTags: ["Articles"],
    }),
  }),
});

export const {
  useGetArticlesQuery,
  useCreateArticleMutation,
  useUpdateArticleMutation,
  useDeleteArticleMutation,
  useLazyGetArticleQuery,
  useGetArticleStatsQuery,
  useStatusUpdateArticleMutation,
} = articleApi;
